/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_ally_low_mana = require('./Q_ally_low_mana');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_full_AP = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.NO] = new Q_ally_low_mana(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'mystic_focus')) {
    node.branches[node.YES] = new UseAbility(actor, 'mystic_focus', actor);
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  node.yesNoEvalFunction = function () {
    return (
      this.actor.ap > this.actor.max_ap * 0.9 &&
      this.actor.mp < this.actor.max_mp * 0.5
    );
  };

  return node;
};
module.exports = Q_full_AP;
